import Loader from './loader';

export default class Login {
    constructor($form) {
        this.$form = $form;
        this.$error = $form.querySelector('[data-error]');
        this.$email = $form.querySelector('#login-email');
        this.$password = $form.querySelector('#login-password');
        this.loader = (new Loader($form.querySelector('[data-loader]')));

        this.submit = this.submit.bind(this);
        this.fetch = this.fetch.bind(this);

        this.$form.addEventListener('submit', this.submit);
    }

    async submit(e) {
        e.preventDefault();
        this.$error.classList.add('d-none');

        if (!this.$email.value || !this.$password.value) {
            this.$error.classList.remove('d-none');
            return false;
        }

        this.loader.loading(true);

        const result = await this.fetch();

        if (result === true) {
            this.$error.classList.add('d-none');
            window.location.href = placeholders.currentUri;
        } else {
            this.$error.classList.remove('d-none');
            this.$password.value = '';
            this.loader.loading(false);
        }
    }

    async fetch() {
        const body = JSON.stringify({
            email: this.$email.value,
            password: this.$password.value,
        });

        try {
            const request = await fetch(
                    placeholders.baseUri
                            ? placeholders.baseUri + '/ajax/type/63/login'
                            : 'ajax/type/63/login',
                    {
                        method: 'POST',
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json'
                        },
                        body: body
                    }
            );
            const result = await request.json();
            return result;
        } catch (e) {
            console.log(e);
            // this.loader.loading(false);
        }
    }
}